import { useQuery } from '@tanstack/react-query';
import { warehouseService } from '../services/warehouseService';

// Get zones by warehouse — active only, this hook backs picker/assignment UI
export const useZones = (warehouseId: number | null) => {
  return useQuery({
    queryKey: ['zones', warehouseId],
    queryFn: () => warehouseService.getZones(warehouseId!, { limit: 100, status: 'active' }),
    enabled: !!warehouseId,
    staleTime: 0, // Always fetch fresh data
    refetchOnMount: true,
  });
};

// Get racks by warehouse
export const useRacks = (warehouseId: number | null) => {
  return useQuery({
    queryKey: ['racks', warehouseId],
    queryFn: () => warehouseService.getRacks(warehouseId!, { limit: 100 }),
    enabled: !!warehouseId,
    staleTime: 0, // Always fetch fresh data
    refetchOnMount: true,
  });
};

// Get locations by rack
export const useLocations = (rackId: number | null) => {
  return useQuery({
    queryKey: ['locations', rackId],
    queryFn: () => warehouseService.getLocations(rackId!, { limit: 100 }),
    enabled: !!rackId,
    staleTime: 0, // Always fetch fresh data
    refetchOnMount: true,
  });
};
